import { Subject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface SignalPacketPayload extends Record<string, any> {

}

export interface SignalPacket {
  type: string;
  payload: SignalPacketPayload;
  timestamp: number;
}

export class SignalService {
  private signalSubject = new Subject<SignalPacket>();

  emit(type: string, payload: SignalPacketPayload): void {
    const packet: SignalPacket = {
      type,
      payload,
      timestamp: Date.now(),
    };
    this.signalSubject.next(packet);
  }

  on(type: string): Observable<SignalPacket> {
    return this.signalSubject.asObservable().pipe(
      filter(packet => packet.type === type)
    );
  }

  all() {
    return this.signalSubject.asObservable();
  }
}

export const signalService = new SignalService();